import React from 'react';
import { Link } from 'react-router-dom';
import logoOnDark from '../../assets/brand/logo-on-dark.svg';

// Internal legal pages use React Router <Link>; Contact is a mailto: <a>.
const LINKS: { label: string; to: string }[] = [
  { label: 'Terms',      to: '/terms' },
  { label: 'Privacy',    to: '/privacy' },
  { label: 'Disclaimer', to: '/disclaimer' },
];

const CONTACT_EMAIL = 'mycryptoplanner@outlook.com';

export function LandingFooter() {
  return (
    <footer
      className="px-6"
      style={{
        borderTop: '0.5px solid rgba(255,255,255,0.06)',
        padding: '32px 24px',
      }}
    >
      <div className="max-w-5xl mx-auto flex flex-col sm:flex-row items-center sm:items-end justify-between gap-4">
        <div className="flex flex-col items-center sm:items-start gap-3">
          <img
            src={logoOnDark}
            alt="MyCryptoPlanner"
            width={112}
            height={63}
            className="block w-[112px] h-auto"
          />
          <div className="text-[11px]" style={{ color: 'rgba(244,241,234,0.4)' }}>
            © 2026 MyCryptoPlanner · Built in Australia 🇦🇺
          </div>
        </div>
        <div className="flex items-center gap-5">
          {LINKS.map((l) => (
            <Link
              key={l.label}
              to={l.to}
              className="text-[11px] transition-opacity hover:opacity-80"
              style={{ color: 'rgba(244,241,234,0.4)' }}
            >
              {l.label}
            </Link>
          ))}
          <a
            href={`mailto:${CONTACT_EMAIL}`}
            className="text-[11px] transition-opacity hover:opacity-80"
            style={{ color: 'rgba(244,241,234,0.4)' }}
          >
            Contact
          </a>
        </div>
      </div>
    </footer>
  );
}
